// Some components like Flex don't support variant prop so this is for storing common styles for those cases.
export const customStyles = {
  container: {
    violetGradient: {
      background:
        'linear-gradient(white, white) padding-box, linear-gradient(to bottom, var(--vg-colors-violetGradient-start), var(--vg-colors-violetGradient-end)) border-box',
      borderLeft: '4px solid transparent',
      border: '2px solid transparent',
      boxShadow: '0px 0px 8px 0px #7047EB4D',
    },
  },
};
